import { useEffect } from 'react';
import { useSelector } from 'react-redux';

import { useSalesForceCRUDActions } from '@mm/state/actions/SalesForceCRUDActions';
import { SalesForceAccount } from '@mm/state/model/SalesForceModel';
import { activeFacebookPageIdSelector } from '@mm/state/selectors/viewSelectors';
import { StoreState } from '@mm/state/store-interfaces';

export const useTagsCommon = (token: SalesForceAccount | undefined) => {
  const activeFbPageId = useSelector(activeFacebookPageIdSelector);
  const tagsEnabled = useSelector(
    (state: StoreState) => state.salesForce.tagsEnabled,
  );
  const { getAvailableTags } = useSalesForceCRUDActions();

  useEffect(() => {
    if (token?.id) {
      getAvailableTags(activeFbPageId, token.id);
    }
  }, [activeFbPageId, token, getAvailableTags]);

  return { tagsEnabled };
};
